import React from "react";

export default function Five() {
  return (
    <div className="die-face fifth-face">
      <div className="column">
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
      <div className="fifth-center">
        <span className="dot"></span>
      </div>
      <div className="column">
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    </div>
  );
}
